import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

const getClusterClinicalType = (markers) => {
  const hasCases = markers.some((marker) => marker?.options?.clinicalLayerName === 'Casos');
  const hasContacts = markers.some((marker) => marker?.options?.clinicalLayerName === 'Contactos');

  if (hasCases && hasContacts) return 'mixed';
  if (hasCases) return 'case';
  if (hasContacts) return 'contact';
  return 'default';
};

const createClusterIcon = (cluster) => {
  const markers = cluster.getAllChildMarkers();
  const count = cluster.getChildCount();
  const clinicalType = getClusterClinicalType(markers);
  const className = `gis-cluster-marker gis-cluster-marker-${clinicalType}`;

  return L.divIcon({
    html: `<span>${count}</span>`,
    className,
    iconSize: [38, 38],
    iconAnchor: [19, 19],
  });
};

// points: [{lat, lng, ...}]
// renderMarker: (point, i) => L.Marker
export default function ClusterGroup({ points, renderMarker }) {
  const map = useMap();
  useEffect(() => {
    if (!map) return;
    const clusterLayer = typeof L.markerClusterGroup === 'function'
      ? L.markerClusterGroup({
        iconCreateFunction: createClusterIcon,
        maxClusterRadius: 46,
        spiderfyOnMaxZoom: true,
        showCoverageOnHover: false,
      })
      : L.layerGroup();
    const markers = points.map((p, i) => renderMarker(p, i)).filter(Boolean);
    markers.forEach(m => clusterLayer.addLayer(m));
    map.addLayer(clusterLayer);
    return () => {
      map.removeLayer(clusterLayer);
    };
  }, [map, points, renderMarker]);
  return null;
}
